<template>
  <div class="core-function-and-service">
    <div class="title">核心功能及服务</div>
    <el-tabs  class="box" v-model="activeName" :stretch="true">
      <el-tab-pane v-for="item in functionAndServices" :key="item.id" :label="item.label" :name="item.name">
        <div>
          <div class="label">{{ item.label }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
        <img :src="item.src" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
	export default {
		name: 'PlatformAdvantage',
		data() {
      return {
        activeName: 'sheduling',
        functionAndServices: [
          {
            id: 0,
            name: 'sheduling',
            label: '算力调度',
            content: '高效地分配、管理、监控和弹性调度GPU等异构资源算力，提供分布式并行训练能力。',
            src: require('@/assets/images/sheduling.png')
          },
          {
            id: 1,
            name: 'environment',
            label: '训练环境',
            content: '各种AI框架: TensorFlow、Keras、PyTorch等，灵活的MLab交互式工具和训练环境。',
            src: require('@/assets/images/environment.png')
          },
          {
            id: 2,
            name: 'task',
            label: '训练任务',
            content: '高效作业管理，AI训练任务提交和管理，高效算法模型训练能力。',
            src: require('@/assets/images/task.png')
          },
          {
            id: 3,
            name: 'datamanage',
            label: '数据管理',
            content: '数据标注/管理: 模型溯源、快照/版本管理、共享等功能，模型一键发布至平台共享和统一管理。',
            src: require('@/assets/images/datamanage.png')
          },
          {
            id: 4,
            name: 'modelcenter',
            label: '模型中心',
            content: '各类算法和模型服务通过PaaS能力输出并提供给开发者和其它智能应用使用。',
            src: require('@/assets/images/modelcenter.png')
          },
        ],
      }
    },
	}
</script>

<style>

	@media (min-width:992px) {
    .core-function-and-service {
      background: url("../assets/images/corefunction-and-services.png");
      height: 806px;
    }

    .core-function-and-service .title {
      margin: 110px auto 0;
      width: 210px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 34px;
      display: inline-block;
    }

		.core-function-and-service .box {
      width: 1400px;
      margin: 60px auto;
		}

		.core-function-and-service .box .el-tabs__header {
			margin: 0 auto;
		}
    .core-function-and-service .box .el-tabs__item {
      width: 104px;
      height: 37px;
      font-size: 26px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 37px;
      margin-bottom: 22px;
      opacity: 0.7;
    }
    .core-function-and-service .box .el-tabs__item.is-active {
      opacity: 1;
    }
    .core-function-and-service .box .el-tab-pane .label {
      margin-top: 150px;
      width: 128px;
      height: 45px;
      font-size: 32px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 45px;
    }
    .core-function-and-service .box .el-tab-pane .content {
      width: 619px;
      height: 77px;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 36px;
      margin-top: 40px;
      text-align: start;
      opacity: 0.7;
    }
    .core-function-and-service .box .el-tab-pane img {
      margin-top: 98px;
      margin-right: 45px;
    }
    .core-function-and-service .box .el-tab-pane {
      display: flex;
      align-items: start;
      justify-content: space-between;
    }

		.core-function-and-service .box .item:hover {
			border-bottom: 4px solid #3890FF;
			box-shadow: 0px 2px 7px 0px rgba(158, 158, 237, 0.4);
			margin-bottom: -7px;
		}
	}

	.core-function-and-service .box .item .up {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-bottom: 33px;
	}

	.core-function-and-service .box .item .up h4 {
		margin: 24px 0 0 24px;
		color: #333333;
		font-size: 16px;
		font-weight: 500;
		line-height: 1.1;
		font-family: "microsoft yahei";
	}

	.core-function-and-service .box .item p {
		text-align: left;
		color: #777;
		font-family: "microsoft yahei";
		font-size: 14px;
		line-height: 1.5;
	}

	@media (max-width:992px) {
		.core-function-and-service .title {
			padding-top: 10px;
			margin-bottom: 15px;
		}

		.core-function-and-service .title h2 {
			font-size: 18px;
			line-height: 60px;
		}

		.core-function-and-service .title .vertical::before {
			content: '';
			display: block;
			position: absolute;
			top: 3px;
			left: -12px;
			width: 4px;
			height: 18px;
			background-color: #25A5FF;
		}

		.core-function-and-service .box {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 10px;
			padding: 0;
		}

		.core-function-and-service .box .item {
			margin: 0;
			padding: 0;
		}

		.core-function-and-service .box .item .up {
			height: 60px;
			padding: 3px 10px;
			margin-bottom: 3px;
			background-color: rgba(52, 156, 227, .1);
			align-items: center;
			border-radius: 4px;
		}

		.core-function-and-service .box .item .up img {
			height: 50px;
		}

		.core-function-and-service .box .item .up h4 {
			margin: 0 0 0 5px;
		}
		.core-function-and-service .box .item p {
			margin: 0 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/CoreFunctionAndServices.vue